<template>
    <!-- Modal -->
    <div

        @click.self="closeModal"
        class="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50"
        role="dialog"
        aria-labelledby="modal-title"
        aria-modal="true"
    >
        <div class="bg-white rounded-lg shadow-xl w-full max-w-md">
            <!-- Header -->
            <div class="px-6 pt-6 pb-4 border-b border-gray-200">
                <h2 id="modal-title" class="text-xl font-semibold text-gray-900">
                   Evaluez votre expérience
                </h2>
            </div>

            <!-- Contenu -->
            <div class="px-6 py-6">
                <!-- Système de notation -->
                <div class="mb-6">
                    <label class=" block text-sm font-medium text-gray-700 mb-3">
                        Votre note <span  class="text-sm text-gray-600 mt-2">
                                    ({{ displayRating }} étoile{{ displayRating > 1 ? 's' : '' }})
                                </span>
                    </label>
                    <div
                        class="flex items-center justify-center gap-1"
                        @mouseleave="unhoverRating"
                        role="radiogroup"
                        aria-label="Notation sur 5 étoiles"
                    >
                        <button
                            v-for="star in 5"
                            :key="star"
                            @click="selectRating(star)"
                            @mouseenter="hoverRating(star)"
                            @keydown="handleKeydown($event, star)"
                            class="p-1 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors duration-150"
                            :class="{
                                              'text-yellow-400': star <= displayRating,
                                              'text-gray-300': star > displayRating
                                            }"
                            role="radio"
                            :aria-checked="star === rating"
                            :aria-label="`${star} étoile${star > 1 ? 's' : ''}`"
                            tabindex="0"
                        >
                            <svg class="w-10 h-10 fill-current" viewBox="0 0 20 20">
                                <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z"/>
                            </svg>
                        </button>
                    </div>



                </div>

                <!-- Zone de commentaire -->
                <div class="mb-6">
                    <label for="comment" class="block text-sm font-medium text-gray-700 mb-2">
                        Commentaire <span class="text-gray-400">(facultatif)</span>
                    </label>
                    <textarea
                        id="comment"
                        v-model="comment"
                        rows="4"
                        placeholder="Partagez votre avis sur ce livre..."
                        class="w-full px-3 py-2 border border-gray-300 rounded-lg resize-none focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                        maxlength="500"
                    ></textarea>
                    <p class="text-xs text-gray-500 mt-1">
                        {{ comment?.length }}/250 caractères
                    </p>
                </div>

            </div>

            <!-- Footer -->
            <div class="px-6 py-4 bg-gray-50 border-t border-gray-200 rounded-b-xl flex justify-end gap-3">
                <button
                    @click="closeModal"
                    :disabled="isSubmitting"
                    class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
                >
                    Plus tard
                </button>
                <button
                    @click="submitRating"
                    :disabled="isSubmitting"
                    class="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200 flex items-center gap-2"
                >
                    <svg v-if="isSubmitting" class="animate-spin h-4 w-4" fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    {{ isSubmitting ? 'Envoi...' : 'Envoyer l\'évaluation' }}
                </button>
            </div>
        </div>
    </div>
</template>

<script setup>
import {computed, ref} from 'vue'
import axios from 'axios'
import {NotificationToast} from "@/utils/notification.js";

// États
const isSubmitting = ref(false)
const emit=defineEmits(['close'])
const rating = ref(0)
const comment = ref('')
const hoveredRating = ref(0)
const displayRating = computed(() => hoveredRating.value || rating.value)

const selectRating = (stars) => {
    rating.value = stars
}

const hoverRating = (stars) => {
    hoveredRating.value = stars
}

const unhoverRating = () => {
    hoveredRating.value = 0
}


function closeModal() {
    emit('close')
}

async function submitRating() {

    if (rating.value < 1) return NotificationToast('error','Vueillez selectionner au moins une étoile!')
    isSubmitting.value=true
     const response=await axios.post('/library_rating', {
        rating: rating.value,
        comment: comment.value
    })
    if (response.data){
        NotificationToast(response.data.type,response.data.message)
    }
    isSubmitting.value=false
    closeModal()
}
</script>
